import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function CustomModal(props) {
    return (
        <Modal isOpen={props.isTheModalOpen} toggle={props.modalToggle}
            size={props.size || "lg"} style={props.style}>

            <ModalHeader toggle={props.modalToggle}>
                {props.title}
            </ModalHeader>

            <ModalBody style={{ paddingTop: 0, paddingBottom: 0 }}>
                {props.children}
            </ModalBody>

            <ModalFooter>
                {getFooterButtons(props)}
                <Button color="secondary" onClick={props.modalToggle}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    );
}

function getFooterButtons(props) {
    if (props.footerButtons !== undefined) {
        return props.footerButtons
    }
}

export default CustomModal;